const state = {
    error: ''
}

const mutations = {
    set_error(state, payload) {
        state.error = payload
    },
    clear_error(state) {
        state.error = ''
    }
}

const actions = {
    setError({ commit }, payload) {
        commit('set_error', payload)
    },
    clearError({ commit }) {
        commit('clear_error')
    }
}

const getters = {
    error: state => state.error
}

export default { state, actions, mutations, getters }
